"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Multi-device Conversation is a Preview feature.
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConversationExpirationEventArgs = void 0;
const Exports_js_1 = require("../Exports.js");
class ConversationExpirationEventArgs extends Exports_js_1.SessionEventArgs {
    constructor(expirationTime, sessionId) {
        super(sessionId);
        this.privExpirationTime = expirationTime;
    }
    /** How much longer until the conversation expires (in minutes). */
    get expirationTime() {
        return this.privExpirationTime;
    }
}
exports.ConversationExpirationEventArgs = ConversationExpirationEventArgs;

//# sourceMappingURL=ConversationExpirationEventArgs.js.map
